export default {
  buttons: {
    login: 'Login',
    resend_code: 'Resend code via SMS',
  },
  placeholders: {
    code: 'Code',
  },
  labels: {
    not_receive_code: 'Didn`t receive the code?',
  },
};
